var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('s-location',{attrs:{"info":"","title":"경유증표 종류"}}),_c('div',{staticClass:"html_cont",domProps:{"innerHTML":_vm._s(_vm.sitem.cont)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }